import { CheckIcon } from './icons';
import { useI18n } from '../i18n';
import type { TranslationKey } from '../i18n/translations';

const STEPS: TranslationKey[] = ['workspace.stepPrepare', 'workspace.stepBuild', 'workspace.stepInstall'];

export default function PublishSteps({ active }: { active: number }) {
  const { t } = useI18n();
  return (
    <ol className="publish-steps" aria-label={t('workspace.publishJourney')}>
      {STEPS.map((key, index) => (
        <li key={key} className={index === active ? 'is-current' : index < active ? 'is-complete' : ''} aria-current={index === active ? 'step' : undefined}>
          <span className="step-marker" aria-hidden="true">{index < active ? <CheckIcon size={14} /> : index + 1}</span>
          <span>{t(key)}</span>
        </li>
      ))}
    </ol>
  );
}
